import React, { useContext } from "react";
import PropTypes from "prop-types";
import Overlay from "../../Overlay";
import Button from "../../common/Button";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";

import { ReactComponent as WarningSvg } from "../../../assets/workExchange/icon-warning.svg";

//style
import "../../../styles/allWorkExchangeModal.scss";

function DeletePopup({ onClose, handleConfirmDelete }) {
  const { getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  return (
    <Overlay
      onClose={onClose}
      style={{
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      <div className="delete-container">
        <div className="delete-container-content">
          <WarningSvg />
          <div className="delete-container-content-title">
            {TranslationWorkExchange("Delete work exchange")}
          </div>
          <div className="delete-container-content-footer">
            <Button
              variant={"secondary"}
              label={TranslationCommon("Cancel")}
              onClick={onClose}
            />
            <Button label={TranslationCommon("Confirm")} onClick={handleConfirmDelete} />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

DeletePopup.propTypes = {};

export default DeletePopup;
